export const isDesktopRuntime = typeof window !== 'undefined' && !!window.desktopAPI;

export const navigateOrRedirect = (targetPath, { replace = false } = {}) => {
  if (!targetPath) return;

  if (isDesktopRuntime && targetPath.startsWith('/')) {
    // In packaged Electron (file://), avoid hard reloads to absolute paths.
    if (replace) {
      window.history.replaceState({}, '', targetPath);
    } else {
      window.history.pushState({}, '', targetPath);
    }
    window.dispatchEvent(new PopStateEvent('popstate'));
    return;
  }

  if (replace) {
    window.location.replace(targetPath);
  } else {
    window.location.href = targetPath;
  }
};
